export const MAINTENANCE_BYPASS_STORAGE_KEY = "yudu_maintenance_bypass";

export const MAINTENANCE_BYPASS_PARAM = "maintenance_bypass";

export interface MaintenanceEnv {
  VITE_FULL_MAINTENANCE?: string;
  VITE_MAINTENANCE_BYPASS_CODE?: string;
}

export type MaintenanceBrowser = Pick<Window, "location" | "history" | "localStorage">;

export const isFullMaintenanceOn = (env: MaintenanceEnv): boolean =>
  env.VITE_FULL_MAINTENANCE?.trim() === "true";

const configuredBypassCode = (env: MaintenanceEnv): string =>
  env.VITE_MAINTENANCE_BYPASS_CODE?.trim() ?? "";

function readStoredBypass(browser: MaintenanceBrowser): string | null {
  try {
    return browser.localStorage.getItem(MAINTENANCE_BYPASS_STORAGE_KEY);
  } catch {
    return null;
  }
}

function storeBypass(browser: MaintenanceBrowser, code: string): boolean {
  try {
    browser.localStorage.setItem(MAINTENANCE_BYPASS_STORAGE_KEY, code);

    return true;
  } catch {
    return false;
  }
}

function consumeBypassParam(browser: MaintenanceBrowser, code: string): void {
  const url = new URL(browser.location.href);

  if (url.searchParams.get(MAINTENANCE_BYPASS_PARAM) !== code) return;

  if (!storeBypass(browser, code)) return;
  url.searchParams.delete(MAINTENANCE_BYPASS_PARAM);
  browser.history.replaceState(browser.history.state, "", `${url.pathname}${url.search}${url.hash}`);
}

export function shouldShowFullMaintenance(
  env: MaintenanceEnv,
  browser: MaintenanceBrowser = window,
): boolean {
  if (!isFullMaintenanceOn(env)) return false;
  const code = configuredBypassCode(env);

  if (code === "") return true;
  consumeBypassParam(browser, code);

  return readStoredBypass(browser) !== code;
}
